(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MaterialDialogController', MaterialDialogController);

    MaterialDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Material', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', '$localStorage'];

    function MaterialDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Material, MessageService,
        Upload, UidService, ThemeClassify, $localStorage) {
        var vm = this;

        vm.type = entity.state;
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                type: entity.type || 'CLIPART',
                keys: []
            }
        }
        vm.attachments = [];
        vm.imgs = [];
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: entity.type || 'CLIPART'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                Material.getone({id: entity.data.id},function (res) {
                    if(res.status==200){
                        vm.data = res.data;
                    }else{
                        MessageService.error(res.message);
                        return
                    }
                });
            }

        })

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }
        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            vm.data.keys.splice(index,1);
        };

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(entity.state == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择图片");
                    return
                }
            }
            console.log(vm.data)
            vm.isSaving = true;
            if (vm.data.id != null) {
                Material.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Material.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (result) {
                MessageService.success("素材保存成功");
                $uibModalInstance.close(result);
                vm.isSaving = false;
            };

            function onSaveError () {
                MessageService.error("素材保存失败");
                vm.isSaving = false;
            };
        }
    }
})();
